module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "fineprint"
  }, [_vm._l(([].concat(_vm.data.body)), function(paragraph, key) {
    return _c('p', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(paragraph)
      }
    })
  }), _vm._v(" "), _c('ul', _vm._l((_vm.data.list), function(listItem, key) {
    return _c('li', {
      key: key,
      domProps: {
        "innerHTML": _vm._s(listItem)
      }
    })
  }), 0)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1edc75f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/block/BlockFineprint.vue
// module id = 664
// module chunks = 0